<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            EDIT - ANIMAL VACCINE DETAIL
            </h2>
          <!--<p>Edit animal vaccine detail</p>-->
          <!--<a (click)="backnavigate()"  class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
          </a>-->
          </div>
      </div>
      <br>
       <form class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name" >Vaccine Name</label>
            <input
              type="text"
              name="vaccinename"
              id="vaccinename"
              class="form-control"
              [(ngModel)]="vaccine_name"
            >
            </div>
         </div>
          <div class="col-lg-4 col-md-6 col-sm-6"> 
            <div class="form-group">
              <label for="Species Name" >Batch No</label>
              <input
                type="text"
                name="batchNumber"
                id="batchNumber"
                class="form-control"
                [(ngModel)]="batch_no"
              >
              </div>
           </div>
         <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name" >Expiry Date </label>
            <input
              type="date"
              id="ExpiryDate"
              name="ExpiryDate"
              class="form-control"
              [(ngModel)]="expiry_date"
            >
            </div>
         </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="row">
 <div class="col-lg-6 col-md-6 col-sm-6">
  <div class="form-group">
    <label for="fromage">Dose Value</label>
    <input
      type="number"
      id="dosevalue"
      name="dosevalue"
      class="form-control"
      min="0"
      max="50"
      step="1"
      [(ngModel)]="dose_value"
    >
</div>
</div>
 <div class="col-lg-6 col-md-6 col-sm-6">
  <div class="form-group">
    <label for="toage">Units</label>
    <input
      type="text"
      id="unit"
      name="unit"
      class="form-control"
      [(ngModel)]="units"
    >
 </div>
 </div>
 </div>
</div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Vaccine Date 1</label>
          <input
            type="date"
            name="VaccineDate1"
            id="VaccineDate1"
            class="form-control"
            [(ngModel)]="vaccine_date1"
          >
          </div>
       </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="remark">Remark</label>

              <input
                type="text"
                name="remark"
                id="remark"
                class="form-control"
                [(ngModel)]="remark"
                placeholder="Enter Here"
              >
          </div>
        </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <button type="submit" class="btn btn-fill btn-primary mb-3"  (click)="AnimalVaccine()">Submit<div class="ripple-container"></div></button>
        <button  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
        </div>
       </form>
      
     </div>
   </div>
  </div>
  
  
